export enum LANDING_SCREEN_TEST_IDS {
    SIGNIN_BUTTON = 'landing_screen_signin_button',
    SIGNUP_BUTTON = 'landing_screen_signup_button',
    LOOK_AROUND_BUTTON = 'landing_screen_look_around_button',
    LANDING_IMAGE_LOGO = 'landing_screen_logo',
    LANDING_IMAGE_BACKGROUND = 'landing_screen_image_background',
    HEADLINE = 'landing_screen_headline',
    SUBTITLE = 'landing_screen_subtitle',
}
